import axios from "axios";

const API_URL = `${process.env.REACT_APP_STRAPI_URL}/api`;

export const getNovedades = async () => {
  try {
    const response = await axios.get(`${API_URL}/novedades`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo novedades:", error);
    return [];
  }
};

export const getEventos = async () => {
  try {
    const response = await axios.get(`${API_URL}/eventos`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo eventos:", error);
    return [];
  }
};
//Testimonios--------------->
export const getTestimonioById = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonios?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo testimonio por id:", error);
    return null;
  }
};

export const getTestimonioMarcas = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonio-marcas`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo marca:", error);
    return null;
  }
};
export const getTestimonioUSer = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonios-users?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo user", error);
    return null;
  }
};
export const getClientes = async () => {
  try {
    const response = await axios.get(`${API_URL}/clientes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo clientes:", error);
    return null;
  }
};
export const getHomeHero = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo clientes:", error);
    return null;
  }
};

export const getHeroInsurances = async () => {
  try {
    const response = await axios.get(`${API_URL}/hero-insurances?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo clientes:", error);
    return null;
  }
};
export const getHeroComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/hero-comexes?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo heroBox:", error);
    return null;
  }
};
export const getBeneficiosComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/beneficios-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo beneficios-comexes:", error);
    return null;
  }
};

export const getAutomotrizComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/automotriz-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo automotriz-comexes:", error);
    return null;
  }
};

export const getContactoComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/contacto-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo contacto-comexes:", error);
    return null;
  }
};

export const getMarcasComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/marcas-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo marcas-comexes:", error);
    return null;
  }
};

export const getTestimonioComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/testimonio-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo testimonio-comexes:", error);
    return null;
  }
};

export const getVideoComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/video-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo video-comexes:", error);
    return null;
  }
};
export const getCertificaciones = async () => {
  try {
    const response = await axios.get(`${API_URL}/certificaciones?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo video-comexes:", error);
    return null;
  }
};
export const getContactosHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/contactos-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo contactos-heroes:", error);
    return null;
  }
};

export const getMreHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/mre-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo mre-heroes:", error);
    return null;
  }
};

export const getNosotrosHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/nosotros-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo nosotros-heroes:", error);
    return null;
  }
};

export const getNosotrosTeams = async () => {
  try {
    const response = await axios.get(`${API_URL}/nosotros-teams?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo nosotros-teams:", error);
    return null;
  }
};

export const getPayHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/pay-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo pay-heroes:", error);
    return null;
  }
};

export const getSmartReaderHeroes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/smart-reader-heroes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo smart-reader-heroes:", error);
    return null;
  }
};

export const getMisimHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/misim-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo misim-heroes:", error);
    return null;
  }
};
